import { IState } from 'shared/store';
import { TNewbuildingComparisonStatus } from 'shared/types/newbuildingComparison';

/**
 * Статус сравнения ЖК: значение из стейта имеет приоритет (обновляется при добавлении/удалении),
 * до первого действия пользователя используется статус из ответа get-offer-data.
 */
export function getNewbuildingComparisonStatus(state: IState): TNewbuildingComparisonStatus | null {
  return state.newbuildingComparison.comparisonStatus ?? state.offerData.newObject?.comparisonStatus ?? null;
}
